import { graphql, useStaticQuery } from 'gatsby';

import ImageTextSection from '../index/image-text';
import React from 'react';
import SectionTitle from '../shared/section-titles';
import constants from './../../constants/home';

const ImageSection = ({ isIndefinite }) => {
	const data = useStaticQuery(graphql`
		query HomePageImageTextQuery {
			home: wordpressPage(slug: { eq: "za-doma" }) {
				acf {
					reason_1_title
					reason_1_text
					reason_2_title
					reason_2_text
				}
			}
			homeIndefinite: wordpressPage(slug: { eq: "za-doma-bezsrochni" }) {
				acf {
					reason_1_title
					reason_1_text
					reason_2_title
					reason_2_text
				}
			}
			forTV: file(relativePath: { eq: "home/tv.png" }) {
				childImageSharp {
					fluid(maxHeight: 700, quality: 90) {
						...GatsbyImageSharpFluid_withWebp_noBase64
					}
				}
			}
			forInternet: file(relativePath: { eq: "home/net.png" }) {
				childImageSharp {
					fluid(maxHeight: 700) {
						...GatsbyImageSharpFluid_withWebp_noBase64
					}
				}
			}
			forTVUndefinite: file(relativePath: { eq: "home/tv-bezsrochni.png" }) {
				childImageSharp {
					fluid(maxHeight: 700, quality: 90) {
						...GatsbyImageSharpFluid_withWebp_noBase64
					}
				}
			}
			forInternetUndefinite: file(relativePath: { eq: "home/net-bezsrochni.png" }) {
				childImageSharp {
					fluid(maxHeight: 700) {
						...GatsbyImageSharpFluid_withWebp_noBase64
					}
				}
			}
		}
	`);
	const usedData = isIndefinite ? data.homeIndefinite : data.home;

	return (
		<>
			<section id="home-image-text">
				<SectionTitle>
					<h2 style={{ whiteSpace: 'pre-wrap' }}>Защо да избереш NetSurf</h2>
					<hr className="center " />
				</SectionTitle>

				<ImageTextSection
					imgSrc={
						isIndefinite
							? data.forInternetUndefinite.childImageSharp.fluid
							: data.forInternet.childImageSharp.fluid
					}
					imgAlt={
						isIndefinite
							? 'internet i televiziq bez dogovor'
							: 'internet i televiziq s dogovor'
					}
					sectionTitle={usedData.acf.reason_1_title}
					undertext={usedData.acf.reason_1_text}
					list={constants.forInternet.list}
					order={true}
				/>

				<ImageTextSection
					imgSrc={
						isIndefinite
							? data.forTVUndefinite.childImageSharp.fluid
							: data.forTV.childImageSharp.fluid
					}
					imgAlt={
						isIndefinite
							? 'internet i televiziq bez dogovor'
							: 'internet i televiziq s dogovor'
					}
					sectionTitle={usedData.acf.reason_2_title}
					undertext={usedData.acf.reason_2_text}
					list={constants.forTV.list}
					order={false}
					skipLeft={true}
				/>
			</section>
		</>
	);
};

export default ImageSection;

